import { Component, Input } from "@angular/core";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { loaderItems } from "../../../../../../../../shared/src/lib/utils/common";

@Component({
  selector: "app-in-play-loader",
  imports: [NgxSkeletonLoaderModule],
  templateUrl: "./in-play-loader.component.html",
  styleUrl: "./in-play-loader.component.scss",
})
export class InPlayLoaderComponent {
  @Input() show: boolean | null = false;
  protected readonly loaderItems = loaderItems;
}
